var exports = {
  "Cr": "reviewerList__XUeF5Q",
  "wI": "reviewerRow__GGvypX",
  "gx": "reviewerIdentity__UzEbKQ",
  "h3": "reviewerAvatar__D2Jz--",
  "JG": "reviewerName__kuuPXF",
  "$U": "statusDescription__skvSaa",
  "Yc": "reviewerIdentityColumn__T4ETBs",
  "j4": "reviewerIdentityGroup__T4IAow",
  "MT": "withEffortMenu__-98tTK",
  "_6": "effortMenu__5YM-Q0",
  "g5": "effortMenuButton__JCk9rq",
  "iY": "effortFooter__0RF1Vs",
  "H": "effortFooterText__WPH1vl",
  "aA": "mutationError__OKVpwY",
  "qv": "requestButton__sGNIOJ",
  "ej": "requestRow__-0sCBz",
  "Lv": "inlineReviewerIdentity__XhGjHa",
  "Ur": "inlineReviewerName__vIIrF4",
  "hD": "indicators__g13EPv",
  "I8": "statusIcon__gxAEMz",
  "p$": "emptyState__iSUqon",
  "vg": "unqualifiedReviewersGroup__FdkMxq",
  "UH": "moreReviewersToggle__wVTarx",
  "HS": "moreReviewersChevron__czWBg7",
  "Oz": "moreReviewersChevronExpanded__xrDKYr",
  "IR": "nestedMemberList__ARn9iU",
  "Uo": "nestedReviewerItem__kWFt2X",
  "M3": "connector__mYLXWo",
  "WW": "connectorLast__0F5Qxp",
};

module.exports = exports;
